import React from "react";
import { useAppContext } from "../contexts/AppContext";

const TaskList = () => {
  const { tasks, deleteTask } = useAppContext();

  return (
    <div>
      <h2>Task List</h2>
      <ul>
        {tasks.map((task) => (
          <li key={task.id}>
            {task.title}
            <button onClick={() => deleteTask(task.id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TaskList;
